import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { fmtPct } from '../../../core/i18n/labels';

/** Δ-chip: consistent MoM / YoY change indicator across the whole app. */
@Component({
  selector: 'app-delta-chip',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './delta-chip.component.html',
  styleUrl: './delta-chip.component.scss',
})
export class DeltaChipComponent {
  /** Percent change value. */
  value = input.required<number | null | undefined>();
  /** 'МоМ' | 'ГоГ' | custom. */
  label = input<string>('ГоГ');
  /** When true, positive change is styled as bad (e.g. affordability). */
  invert = input<boolean>(false);

  text = computed(() => fmtPct(this.value()));
  isFlat = computed(() => Math.abs(this.value() ?? 0) < 0.05);
  isUp = computed(() => {
    const v = this.value() ?? 0;
    return !this.isFlat() && (this.invert() ? v < 0 : v > 0);
  });
  isDown = computed(() => {
    const v = this.value() ?? 0;
    return !this.isFlat() && (this.invert() ? v > 0 : v < 0);
  });
}
